import { i18n, inject, pr, React, observer } from "aaa";
import externalInterfaceStore, { ExitError, ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { MessageScreen } from "./MessageScreen";

export type Props = i18n.InjectedIntlProps &
{
    externalInterfaceStore: ExternalInterfaceStore;
    exitError?: ExitError;
    title?: string;
    message?: string;
    buttonLabelId?: i18n.IDS;
    hideButton?: boolean;
    onDismiss?: () => void;
    match?: {
        params: {
            messageId: string;
        }
    },
    useWebVersion?: boolean
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class ErrorScreen extends React.Component<Props, {}> {
    render() {
        const __ = i18n.bindStr(this.props.intl);

        let message = this.props.message ? this.props.message : __("error.generic.message");
        if (this.props.match && this.props.match.params.messageId) {
            message = __(this.props.match.params.messageId as any);
        }

        let buttonLabelId = this.props.buttonLabelId || !externalInterfaceStore.isGeorgeApp ? this.props.buttonLabelId : "error.closebutton.title";

        const handleDismiss = () => {
            // Return to container app
            this.props.externalInterfaceStore.raiseExitError(this.props.exitError ? this.props.exitError : "unknown");
        };

        return (
            <MessageScreen
                useWebVersion
                variant="danger"
                icon={pr.IconMessageError}
                title={this.props.title ? this.props.title : __("error.generic.title")}
                message={message}
                buttonLabelId={this.props.hideButton ? undefined : buttonLabelId}
                onDismiss={this.props.onDismiss ?? handleDismiss}
            />
        );
    }
}

export default ErrorScreen;



// WEBPACK FOOTER //
// ./src/components/common/ErrorScreen.tsx